import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LoginDialogService {
  toggle: Subject<any> = new Subject();

  constructor() {}
}
